<template>
  <v-tooltip bottom v-if="situacao">
    <template v-slot:activator="{ on }">
      <v-icon right :class="`pb-1 ${textColorClass}`" v-on="on">
        mdi-circle-medium
      </v-icon>
    </template>
    <span>{{ description }}</span>
  </v-tooltip>
</template>

<script>
import { SituacaoAprovacao } from 'px-business-components';

const TEXT_COLOR_MAP = {
  APROVADO: 'green--text text--darken-3',
  PENDENTE: 'yellow--text text--darken-3',
  RECUSADO: 'error--text',
};

export default {
  props: {
    situacao: String,
  },
  computed: {
    description() {
      if (!this.situacao) {
        return '';
      }
      return SituacaoAprovacao.keys[this.situacao].description;
    },
    textColorClass() {
      return TEXT_COLOR_MAP[this.situacao];
    },
  },
};
</script>
